const actions = {
  createMessage: 'createMessage',
  callApi: 'callApi',
  callGraph: 'callGraph',
  initialiseApp: 'initialiseApp'
}

export const {
  createMessage,
  initialiseApp
} = actions

export default actions
